<template>
  <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
    <div>
      <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 10px;"
        :rules="rules"
        ref="ruleForm"
      >
        <a-form-model-item label="Khách hàng" prop="name">
          <a-input v-model="form.name" placeholder="Nhập khách hàng..." />
        </a-form-model-item>
        <a-form-model-item label="Mã" prop="code">
          <a-input v-model="form.code" placeholder="Enter text" />
        </a-form-model-item>
        <a-form-model-item label="End User Class" prop="endUserClass">
          <a-input v-model="form.endUserClass" placeholder="Enter text" />
        </a-form-model-item>
        <a-form-model-item label="Địa chỉ" prop="address">
          <a-textarea
            rows="3"
            v-model="form.address"
            placeholder="Nhập địa chỉ..."
          />
        </a-form-model-item>
        <a-form-model-item label="Mã thuế">
          <a-input v-model="form.taxCode" placeholder="Nhập mã thuế..." />
        </a-form-model-item>
        <a-form-model-item label="Tài khoản ngân hàng">
          <a-input
            v-model="form.accountBank"
            placeholder="Nhập tài khoản ngân hàng..."
          />
        </a-form-model-item>
        <a-form-model-item label="Điện thoại" prop="tel">
          <a-input v-model="form.tel" placeholder="Nhập điện thoại..." />
        </a-form-model-item>
        <a-form-model-item label="Người đại diện">
          <a-input
            v-model="form.representedBy"
            placeholder="Nhập tên người đại diện..."
          />
        </a-form-model-item>
        <a-form-model-item label="Chức vụ">
          <a-input
            v-model="form.positionRepresentedBy"
            placeholder="Nhập chức vụ của người đại diện..."
          />
        </a-form-model-item>
      </a-form-model>
      <a-divider orientation="left">
        THÔNG TIN CẬP NHẬT
      </a-divider>
      <a-descriptions :column="1">
        <a-descriptions-item label="Tạo bởi">
          {{ form.author && (form.author.fullname || form.author.username) }}
        </a-descriptions-item>
        <a-descriptions-item label="Ngày tạo">
          {{ form.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Cập nhật lần cuối">
          {{ form.updatedAt | formatDateHour }}
        </a-descriptions-item>
      </a-descriptions>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Xác nhận xóa thông tin?"
          ok-text="Có"
          cancel-text="Không"
          @confirm="onDeletedCustomer"
        >
          <a-button
            icon="delete"
            type="danger"
            style="float: left;"
            :loading="loadingBtn"
          >
            Xóa
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 10px;" @click="close">
          Đóng
        </a-button>
        <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
          Cập nhật
        </a-button>
      </div>
    </div>
  </a-skeleton>
</template>
<script>
import typeBenefits from "@/constants/interface/typeBenefits";
import query from "../constant/query";

const rules = {
  name: [{ required: true, message: "Mã không được bỏ trống" }],
};
export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterUpdated: { type: Function, required: true },
    refreshAfterDeleted: { type: Function, required: true },
    idCustomer: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      typeBenefits,
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {
        benefit: typeBenefits?.length > 0 ? typeBenefits[0].id : undefined,
      },
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
      loadingBtn: false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdatedCustomer();
        } else {
          return false;
        }
      });
    },
    onUpdatedCustomer() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateCustomer,
          variables: {
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Cập nhật khách hàng thành công!",
          });
          this.loadingBtn = false;
          if (data?.updateCustomer?.id) {
            this.refreshAfterUpdated(data.updateCustomer);
          }

          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Cập nhật khách hàng không thành công!",
          });
          console.log("Cập nhật khách hàng không thành công", err);
        });
    },
    onGetCustomer() {
      this.loading = true;
      this.$apollo
        .query({
          query: query.getDetailCustomer,
          variables: { id: this.idCustomer },
        })
        .then(({ data }) => {
          this.loading = false;
          if (data?.getDetailCustomer?.id) {
            this.customer = { ...data.getDetailCustomer };
            this.form = { ...data.getDetailCustomer };
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Lấy chi tiết khách hàng không thành công!",
          });
          console.log("Lấy chi tiết khách hàng không thành công", err);
        });
    },
    onDeletedCustomer() {
      if (this?.form?.id) {
        this.loadingBtn = true;
        this.$apollo
          .mutate({
            mutation: query.deleteCustomer,
            variables: {
              id: this.form.id,
            },
          })
          .then(({ data }) => {
            this.$notification.success({
              message: "Thông báo",
              description: "Xóa khách hàng thành công!",
            });
            this.loadingBtn = false;
            if (data?.deleteCustomer?.id) {
              this.refreshAfterDeleted(data.deleteCustomer);
            }

            this.close();
          })
          .catch((err) => {
            this.loadingBtn = false;
            this.$notification.error({
              message: "Thông báo",
              description: "Xóa khách hàng không thành công!",
            });
            console.log("Xóa khách hàng không thành công", err);
          });
      }
    },
  },
  created() {
    this.onGetCustomer();
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
